module.exports = __webpack_public_path__ + "static/media/box-stacking.ebc27f11.mov";